<template>
    <div class="bg-white p-8 md:p-12 font-sans">
        <div class="p-8 sm:p-12 max-w-7xl mx-auto">

            <section class="text-center">
                <h2
                    class="text-4xl lg:text-5xl font-extrabold text-gray-800 inline-flex items-center justify-center flex-wrap gap-x-3 gap-y-2">
                    <span>O</span>
                    <span class="bg-orange-500 text-white rounded-lg px-3 py-1">planejamento</span>
                    <span>na</span>
                    <span>prática</span>
                </h2>
                <p class="mt-6 max-w-3xl mx-auto text-gray-600 text-base lg:text-lg">
                    A <strong class="font-bold text-gray-800">OverX</strong> foi implementada para otimizar a
                    qualificação de leads e a gestão de oportunidades, permitindo que a comunicação entre as equipes
                    fosse mais eficiente e que os dados fossem utilizados para tomadas de decisão mais rápidas.
                </p>
            </section>

            <br />
            <br />
            <br />

            <section class="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                <div class="flex items-stretch gap-6">
                    <div class="flex flex-col items-center gap-4">
                        <p class="writing-mode-vertical text-gray-400 font-semibold tracking-wider uppercase">Análise
                            Inicial</p>
                        <div class="w-px flex-grow bg-gray-300"></div>
                    </div>
                    <div class="flex-1">
                        <h2 class="text-3xl lg:text-4xl font-bold text-orange-500 mb-8">
                            OverX - Resultados na Qualificação de Leads
                        </h2>
                        <ul class="space-y-6">
                            <li class="flex items-start gap-4">
                                <div class="bg-gray-800 text-white p-3 rounded-lg flex-shrink-0">
                                    <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" height="24"
                                        viewBox="0 0 24 24" width="24" fill="currentColor">
                                        <path d="M0 0h24v24H0V0z" fill="none" />
                                        <path d="M3 3h8v8H3zm0 10h8v8H3zm10 0h8v8h-8zm0-10h8v8h-8z" />
                                    </svg>
                                </div>
                                <p class="text-gray-600">
                                    <strong class="text-gray-800">Engajamento da base total de leads: 25,7%</strong>
                                </p>
                            </li>
                            <li class="flex items-start gap-4">
                                <div class="bg-gray-800 text-white p-3 rounded-lg flex-shrink-0">
                                    <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" height="24"
                                        viewBox="0 0 24 24" width="24" fill="currentColor">
                                        <path d="M0 0h24v24H0V0z" fill="none" />
                                        <path
                                            d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" />
                                    </svg>
                                </div>
                                <p class="text-gray-600">
                                    <strong class="text-gray-800">91% dos leads da base foram enviados para o processo
                                        de SDR,</strong> resultando em uma qualificação mais eficiente e na redução de
                                    leads imaturos ou desqualificados, garantindo uma abordagem mais assertiva e
                                    estratégica.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="flex flex-col items-start gap-4">
                    <div class="h-64 w-full flex items-center justify-center rounded-lg text-gray-500">
                        <img src="@/assets/fundo3.png" alt="Exemplo do componente OverX"
                            class="rounded-lg shadow-2xl shadow-orange-500/10">
                    </div>
                </div>
            </section>
            <br />
            <br />
            <br />
            <section class="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                <div class="flex flex-col items-start gap-4">
                    <div class="h-64 w-full flex items-center justify-center rounded-lg text-gray-500">
                        <img src="@/assets/fundo4.png" alt="Exemplo do componente OverX"
                            class="rounded-lg shadow-2xl shadow-orange-500/10">
                    </div>
                </div>
                <div class="flex items-stretch gap-6">
                    <div class="flex flex-col items-center gap-4">
                        <p class="writing-mode-vertical text-gray-400 font-semibold tracking-wider uppercase">Análise
                            Inicial</p>
                        <div class="w-px flex-grow bg-gray-300"></div>
                    </div>
                    <div class="flex-1">
                        <h2 class="text-3xl lg:text-4xl font-bold text-orange-500 mb-8">
                            OverX - Definição de Marca de Interesse
                        </h2>
                        <ul class="space-y-6">
                            <li class="flex items-start gap-4">
                                <div class="bg-gray-800 text-white p-3 rounded-lg flex-shrink-0">
                                    <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" height="24"
                                        viewBox="0 0 24 24" width="24" fill="currentColor">
                                        <path d="M0 0h24v24H0V0z" fill="none" />
                                        <path d="M3 3h8v8H3zm0 10h8v8H3zm10 0h8v8h-8zm0-10h8v8h-8z" />
                                    </svg>
                                </div>
                                <p class="text-gray-600">
                                    <strong class="text-gray-800">Leads engajados: 23,83%</strong>
                                </p>
                            </li>
                            <li class="flex items-start gap-4">
                                <div class="bg-gray-800 text-white p-3 rounded-lg flex-shrink-0">
                                    <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" height="24"
                                        viewBox="0 0 24 24" width="24" fill="currentColor">
                                        <path d="M0 0h24v24H0V0z" fill="none" />
                                        <path
                                            d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" />
                                    </svg>
                                </div>
                                <p class="text-gray-600">
                                    <strong class="text-gray-800">Leads com definição de marca de interesse: 78,14% da
                                        base total,</strong> permitindo uma segmentação precisa e priorizando <span
                                        class="text-orange-500 font-semibold">leads altamente qualificados</span>, o que
                                    levou a um <span class="text-orange-500 font-semibold">aumento significativo na taxa
                                        de conversão</span>.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script setup>
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;700;900&display=swap');

.font-sans {
    font-family: 'Sora', sans-serif;
}

.writing-mode-vertical {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    text-align: center;
}
</style>